export default [
    {
        name: 'Requisições',
        url: '/gescon/aprovadores/requisicoes',
        icon: 'fa fa-file-text-o',
        regras: 'GESCON-APR-REQ-00',
        badge: {
            variant: 'primary',
            text: 'APROVADOR'
        }
    }
]
